// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__n58Ri","content":"GlobalSearch_content__gueFe"};